import { render, staticRenderFns } from "./GuiaDeConsulta.vue?vue&type=template&id=3f83872c&scoped=true&"
import script from "./GuiaDeConsulta.vue?vue&type=script&lang=js&"
export * from "./GuiaDeConsulta.vue?vue&type=script&lang=js&"
import style0 from "./GuiaDeConsulta.vue?vue&type=style&index=0&id=3f83872c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f83872c",
  null
  
)

export default component.exports